import { WorkspaceTimeZoneMatchRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match')({
  component: WorkspaceTimeZoneMatchRoute,
});
